var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscovericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5422_19538",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5422_19538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0039 20.001V11.001H4.00391V20.001H16.0039ZM18.0039 15.001V13.001H20.0039V4.00098H8.00391V9.00098H6.00391V4.00098C6.00391 3.45098 6.19974 2.98014 6.59141 2.58848C6.98307 2.19681 7.45391 2.00098 8.00391 2.00098H20.0039C20.5539 2.00098 21.0247 2.19681 21.4164 2.58848C21.8081 2.98014 22.0039 3.45098 22.0039 4.00098V13.001C22.0039 13.551 21.8081 14.0218 21.4164 14.4135C21.0247 14.8051 20.5539 15.001 20.0039 15.001H18.0039ZM4.00391 22.001C3.45391 22.001 2.98307 21.8051 2.59141 21.4135C2.19974 21.0218 2.00391 20.551 2.00391 20.001V11.001C2.00391 10.451 2.19974 9.98014 2.59141 9.58848C2.98307 9.19681 3.45391 9.00098 4.00391 9.00098H16.0039C16.5539 9.00098 17.0247 9.19681 17.4164 9.58848C17.8081 9.98014 18.0039 10.451 18.0039 11.001V20.001C18.0039 20.551 17.8081 21.0218 17.4164 21.4135C17.0247 21.8051 16.5539 22.001 16.0039 22.001H4.00391Z",
    fill: "#2D2F31"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscovericon);
export default __webpack_public_path__ + "static/media/Discovericon.401663cafc57874136b61ce3d40ec736.svg";
export { ForwardRef as ReactComponent };